import React from 'react';
import { useParams } from 'react-router-dom';
import { ReportType } from '../../models/Portfolio';
import { useAppSelector } from '../../store/reducers/store';
import { Box, Typography } from '@mui/material';
import BackButton from '../../components/common/BackButton';
import { useTranslation } from 'react-i18next';
import ReportsList from '../../components/portfolioDetailsReports/ReportsList';

const PortfolioDetailsReports: React.FC = () => {
    const { type } = useParams()
    const portfolio = useAppSelector(state => state.portfolioDetails.portfolio);
    const { t } = useTranslation();

    if (portfolio === undefined) {
        return <></>;
    }

    let content = <></>;
    if (type === "datarooms") {
        content = <ReportsList reports={portfolio.reports.filter(f => f.type === ReportType.DataRoom)} />
    } else {
        content = <Box display={"flex"} flexDirection={"column"} width={"100%"} gap={"12px"} paddingBottom={"20px"}>
            <Typography fontSize={"16px"} lineHeight={"19.2px"} fontWeight={"600"}>{t('PortfolioDetailsReportsPortfolioReportsAnouncements')}</Typography>
            <ReportsList reports={portfolio.reports.filter(f => f.type === ReportType.Announcement)} withPagination />
            <Typography fontSize={"16px"} lineHeight={"19.2px"} fontWeight={"600"} sx={{ marginTop: "16px" }}>{t('PortfolioDetailsReportsPortfolioReportsQuarterlyReports')}</Typography>
            <ReportsList reports={portfolio.reports.filter(f => f.type === ReportType.QuarterlyReport)} withPagination />
        </Box>
    }

    return <Box display={"flex"} margin={"0"} justifyContent={"center"} overflow={"auto"}>
        <Box display={"flex"} margin={"50px 56px"} alignItems={"center"} flexDirection={"column"} width={"100%"} maxWidth={"1396px"} gap={"27px"}>
            <Box display={"flex"} gap={"12px"} alignItems={"center"} width={"100%"}>
                <BackButton />
                <Typography fontSize={"20px"} fontWeight={"500"} lineHeight={"24.38px"} textAlign={"center"}>{type === "datarooms" ? t('PortfolioDetailsDataRoomsPageTitle') : t('PortfolioDetailsReportsPageTitle')}</Typography>
            </Box>
            {content}
        </Box>
    </Box>;
}

export default PortfolioDetailsReports;